import React, { useContext, useState } from "react";
import FuncionesContext, { getAtributo } from "../../../context/FuncionesContext";
import { useListadoStateApi } from "../../context/ListadoStateContext";

const Boton = ({
  data,
  cab,
  hijos,
  campokey,
  indiceData,
  id_elemento,
  context = {},
}) => {
  const f = useContext(FuncionesContext);
  const _context = useContext(context);
  const listadoStateApi = useListadoStateApi();
  const { datos_seleccionados, datos, sideData, opciones } = _context;
  const [procesando, setProcesando] = useState(false);

  const {
    boton_cursor = "pointer",
    boton_image_height = "40px",
    boton_image_alt = "imagen",
  } = cab;

  const disabled = (() => {
    if (data[cab.id_a + "_disabled"]) {
      return data[cab.id_a + "_disabled"] === "s";
    }

    if (cab.disabled) {
      return cab.disabled === "s";
    }

    return false;
  })();

  const botonDeshabilitado = disabled || procesando;

  const botonStyle = {
    cursor: botonDeshabilitado ? "not-allowed" : boton_cursor,
    opacity: botonDeshabilitado ? 0.5 : 1,
  };

  const boton_texto = getAtributo("boton_texto", data, cab) || "Click Aqui";

  const handleCancelar = () => setProcesando(false);

  const handleClick = async () => {
    if (botonDeshabilitado) return;

    try {
      setProcesando(true);

      const listadoState = listadoStateApi.getState();
      let funcion = "";

      if (cab.funcion_back && cab.funcion_back.trim() !== "") {
        const botonendpoint = `/vistaBoton/` + cab.id_a;
        funcion = "endpoint";

        cab = Object.assign({
          ...cab,
          endpoint: botonendpoint,
          boton_funcion_onClick: funcion,
          funcion_onResponse: cab.boton_funcion_onClick,
          context: _context,
          id_a: cab.id_a,
        });

        if (
          opciones.listado_auto_seleccion === "s" &&
          opciones.listado_seleccion !== "s" &&
          opciones.listado_seleccion_data &&
          opciones.listado_seleccion_data.trim() !== ""
        ) {
          data = datos_seleccionados;
        }
      }

      if (cab.boton_funcion_onClick) {
        funcion = cab.boton_funcion_onClick;
      }

      if (cab.boton_funcion_alias) {
        funcion = data[cab.boton_funcion_onClick_alias];
      }

      if (data[cab.id_a + "_boton_funcion_onClick"]) {
        funcion = data[cab.id_a + "_boton_funcion_onClick"];
      }

      if (
        datos_seleccionados &&
        (cab.listado_seleccion_data || opciones.listado_seleccion_data) &&
        cab.boton_funcion_onClick !== "eliminarRegistro"
      ) {
        const seleccionData =
          cab.listado_seleccion_data ?? opciones.listado_seleccion_data;

        const columnas = seleccionData.split("|");
        let dataS = [];
        let datos_actuales = [];

        if (opciones.isAutoSeleccion) {
          datos_actuales = datos_seleccionados;
        } else {
          const index_seleccionados = datos_seleccionados.map(
            (d) => d.tableData.index
          );

          datos_actuales = datos.filter((d, i) =>
            index_seleccionados.includes(i)
          );
        }

        dataS = datos_actuales.map((r) => {
          let dataArray = [];
          columnas.forEach((c) => dataArray.push(r[c]));
          return dataArray;
        });

        await f[funcion]({
          data: dataS,
          cab,
          handleCancelar,
          sideData,
          context: _context,
          listadoState,
          callback: (r) => setProcesando(false),
        });

        return;
      }

      await f[funcion]({
        data,
        cab,
        indiceData,
        handleCancelar,
        context: _context,
        listadoState,
        callback: (r) => setProcesando(false),
      });

      return;
    } catch (err) {
        console.error("Error en el botón:", err);
      } finally {
        setProcesando(false);
      }
    };

  return (
    <div id={id_elemento} style={{ display: "flex", justifyContent: "center" }}>
      <div
        style={botonStyle}
        onClick={botonDeshabilitado ? undefined : handleClick}
        aria-disabled={botonDeshabilitado}
        className={`${cab.className} ${data[cab.id_a + "_className"] ?? ""} ${
          disabled ? "boton_disabled" : ""
        }`}
      >
        {cab.imagen_url ? (
          <img
            style={{
              cursor: botonDeshabilitado ? "not-allowed" : "pointer",
            }}
            height={boton_image_height}
            src={cab.imagen_url}
            alt={boton_image_alt}
          />
        ) : (
          <div style={{ textAlign: "center" }}>{boton_texto}</div>
        )}
      </div>
    </div>
  );
};

export default Boton;